import { buildApiUrl } from '@/global';
// import { useAuthStore } from '../store/auth.store';

let loggingOut = false;

export async function logout() {
  if (loggingOut) return;
  loggingOut = true;

  let ok = false;
  try {
    const response = await fetch(buildApiUrl('/Cuenta/logoff'), {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    ok = response.ok;
  } catch {
    ok = false;
  }

  // useAuthStore.getState().clearAuth();
  localStorage.clear();

  if (ok) {
    window.location.href = '/login';
  }

  loggingOut = false;
}
